import React from 'react';

import { Stack, Title, Text, Group, Skeleton } from '@mantine/core';
import { IconCalendar, IconClock, IconMapPin, IconUser } from '@tabler/icons-react';
import KiloAlert from 'components/KiloAlert';
import dayjs from 'dayjs';

import useSalesPortalKiloClassFromUrlParam from './useKiloClassFromParam';

function SalesPortalKiloClassInfo(): JSX.Element {
  const {
    data: kiloClassData,
    isLoading: isKiloClassLoading,
    isError: isKiloClassError,
    errorStatus,
  } = useSalesPortalKiloClassFromUrlParam();

  if (isKiloClassLoading) {
    return <Skeleton height={100} />;
  }

  if (isKiloClassError) {
    const errorMessage =
      errorStatus === 404
        ? 'The selected Class may not exist or may not be available.'
        : 'Error loading the selected Class. Please try again later.';
    return (
      <Stack>
        <KiloAlert variantStyle='error'>{errorMessage}</KiloAlert>
      </Stack>
    );
  }

  const kiloClass = kiloClassData?.data;
  const startTime = dayjs(`2000-01-01 ${kiloClass?.startTime}`).format('h:mm A');
  const endTime = kiloClass?.endTime ? dayjs(`2000-01-01 ${kiloClass.endTime}`).format('h:mm A') : '';

  const dateStr = dayjs(kiloClass?.startDate).format('dddd, MMMM DD YYYY');
  const isFull = kiloClass?.availableSpots === 0;

  return (
    <Stack>
      <Title fz='lg' fw='bold'>
        {kiloClass?.className}
      </Title>

      <Stack spacing='xs'>
        <Group>
          <IconCalendar size={20} />
          <Text>{dateStr}</Text>
        </Group>
        <Group>
          <IconClock size={20} />
          <Text>
            {startTime} to {endTime}
          </Text>
        </Group>
        <Group>
          <IconUser size={20} />
          <Text>{kiloClass?.coaches.join(', ') || 'No coach assigned'}</Text>
        </Group>
        {kiloClass?.location && (
          <Group>
            <IconMapPin size={20} />
            <Text>{kiloClass?.location}</Text>
          </Group>
        )}
        <Group>
          <Text>
            Spots:{' '}
            {isFull
              ? 'Full'
              : `${(kiloClass?.capacity ?? 0) - (kiloClass?.availableSpots ?? 0)}/${
                  kiloClass?.capacity ?? 0
                }`}
          </Text>
        </Group>
      </Stack>

      <Text fz='lg' fw='bold'>
        Membership Options to Access this Class
      </Text>
    </Stack>
  );
}

export default SalesPortalKiloClassInfo;
